import React from "react";

// stats: [{ label, value }]
const RightStatsPanel = ({ title, stats }) => (
  <div className="w-[280px] rounded-xl border p-4 bg-white shrink-0">
    {title ? <div className="text-sm font-semibold mb-3 opacity-70">{title}</div> : null}
    <div className="space-y-4">
      {stats.map((s) => (
        <div key={s.label} className="flex flex-col">
          <span className="text-xs tracking-wide opacity-70">{s.label}</span>
          <span className="text-lg font-semibold">{s.value}</span>
        </div>
      ))}
    </div>
  </div>
);

export default RightStatsPanel;
